import { useRef } from "react";

const useEnhancedRef = initialValue => {
  const ref = useRef(initialValue);

  return useRef(value => {
    if (value) {
      ref.current = value;
    }

    return ref.current;
  }).current;
};

export default useEnhancedRef;
